import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';

export const storyRoute: RouteRecordRaw = {
  path: `/story`,
  name: AppScreens.Story,
  component: () => import('@/modules/stories/views/Story.vue'),
  meta: {
    layout: 'main',
  },
};

export const storiesRoute: RouteRecordRaw = {
  path: `/stories`,
  name: AppScreens.Stories,
  component: () => import('@/modules/stories/views/Stories.vue'),
  meta: {
    layout: 'main',
  },
};

